export default __webpack_public_path__ + "static/media/pic1.bd62e573.jpg";